function groupings_Reducer(state = [], action) {
    switch (action.type) {
        case 'GROUPINGS/SET':
            return action.groupings;
        case 'GROUPINGS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default groupings_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/groupings.js